import dayjs from 'dayjs';

export default function TimeOffTotals({ sickLeaves }) {
  /* group by employee – compatible with both data shapes */
  const grouped = sickLeaves.reduce((acc, sl) => {
    const empId   = sl.employee?.id ?? sl.employee_id;
    const empName = sl.employee?.full_name ?? sl.full_name ?? 'Unknown';
    if (!empId) return acc;

    const days =
      dayjs(sl.end_date || sl.start_date).diff(dayjs(sl.start_date), 'day') + 1;

    acc[empId] = acc[empId] || { name: empName, total: 0 };
    acc[empId].total += days;
    return acc;
  }, {});

  const items = Object.values(grouped);

  return (
    <section>
      <h2 className="font-medium mb-2">Yearly Sick Leave Totals</h2>
      <div className="overflow-x-auto">
        <table className="min-w-[400px] w-full text-sm">
          <thead>
            <tr className="bg-gray-50 text-left">
              <th className="px-2 py-1">Employee</th>
              <th className="px-2 py-1">Days taken</th>
            </tr>
          </thead>
          <tbody>
            {items.map(({ name, total }) => (
              <tr key={name} className="border-t">
                <td className="px-2 py-1">{name}</td>
                <td className="px-2 py-1">{total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
